import React from 'react'
import { createTheme, responsiveFontSizes} from '@mui/material/styles'
import DialogContent from '@mui/material/DialogContent';

// import { useDispatch} from 'react-redux';
import FormLabel from '@mui/material/FormLabel';
import Typography from '@mui/material/Typography';
import {GiPlantsAndAnimals} from 'react-icons/gi'
import { bgColors } from '../../utils/bgColor';
import AddLocationSharpIcon from '@mui/icons-material/AddLocationSharp';
import EqualizerSharpIcon from '@mui/icons-material/EqualizerSharp';
import DonutSmallSharpIcon from '@mui/icons-material/DonutSmallSharp';
import CircularProgress from '@mui/material/CircularProgress';
import {BarChart,CropBarChart} from '../../HelperFunctions/Charts/SeasonPerfBarChart'
import {PerfDonut, IrrigationDonut} from "../../HelperFunctions/Charts/AnualPerfDonut"
import CheckBox from '../../FormComopents/Form/CheckBox'
import { Grid } from '@mui/material';
// import { bgFonts } from '../../utils/bgFonts';

let theme = createTheme();
  theme = responsiveFontSizes(theme)

  const stylemaster = {
    root:{
    padding: '0rem',
    color: bgColors.green_700
    // backgroundColor: bgColors.sidebar_grey,
    },
    appbartyle:{
      padding: '0rem',
      color: bgColors.grey_900,
      background:bgColors.green_300,
      maxHeight:'45px'
      },
      paperstyle:{
      height: '200px',
      color: bgColors.default_backgroun_grey,
  
    },
      iconStyle : {
      fontSize:'large',
      padding: '0.1rem',
      color: bgColors.font_blue,
      // background: bgColors.green_300
    },
    title:{
      padding: '0.25rem'
    },
    Typography_body:{
      marginLeft:'2rem', 
      fontSize: 14, 
      fontFamily:'roboto'
    },

    Typography_title:{
      marginLeft:'0rem  ', 
      fontSize: 18, 
      fontFamily:'roboto'
    },
    Typography_header:{
      marginLeft:'0rem  ', 
      fontSize: 24, 
      fontFamily:'roboto'
    },

    GridContainerReportTitle: {
      display:'flex',
      direction:'row',
      justifyContent:'flex-start'
    }
  
  
  }


const LandView=(props) => {


const {location_data,
  perfDonutData, irrigationDonutData, season_crop_cover,
  dataLoader,SeasonalPerfBarData,
  multiBarDataSet
  } = props

  
// const dispatch = useDispatch()
// let openfoliodialog = useSelector(state => state.controlbutton.currentfoliodialog)


  return (
   
    <>
      {/* <Box> */}
   

{/* <Container component="section" maxWidth="lg" style={stylemaster.root}> */}
{/* <Grid container spacing={0.15} alignItems="stretch" > */}
{dataLoader.polyLocationLoading && <CircularProgress syle = {{color:bgColors.grey_300}} />}
{!dataLoader.polyLocationLoading &&
  
  // <Card style={stylemaster.paperstyle}>
  <DialogContent dividers>
  <FormLabel component="legend">  
  <Grid container spacing={1} style={stylemaster.GridContainerReportTitle}>
    <Grid item>
  <AddLocationSharpIcon
            style= {stylemaster.iconStyle}
            />  
    </Grid>
    <Grid item>
    <Typography style={stylemaster.Typography_title}>
      Location 
    </Typography>
    </Grid>
    </Grid>
    </FormLabel>
    
  <Typography style ={stylemaster.Typography_body} key = 'loc_state'> State: {location_data.state}</Typography>
  <Typography style ={stylemaster.Typography_body} key = 'loc_district'> District: {location_data.district}</Typography>
  <Typography style ={stylemaster.Typography_body} key = 'loc_sub_district'> Sub-district: {location_data.sub_district}</Typography>
  <Typography style ={stylemaster.Typography_body} key = 'loc_PinCone'> Pincode: {location_data.pincode}</Typography>
  <Typography style ={stylemaster.Typography_body} key = 'loc_Village'> Village: {location_data.village}</Typography>
  <Typography style ={stylemaster.Typography_body} key = 'loc_Survey_no'> Survey No:
  <Typography variant= 'body' inherit ='p' style ={{marginLeft:'2rem',fontSize: "0.8rem" , wordBreak: "break-word"}}>{location_data.survey_no}</Typography>
  </Typography>
  <Typography style ={stylemaster.Typography_body} key = 'loc_area'> Area in acre: {location_data.area_acre}</Typography>
  <Typography style ={stylemaster.Typography_body} key = 'loc_dist'> Driving distance: {location_data.driving_distance}</Typography>


  </DialogContent>

  // </Card>
  
}

<DialogContent dividers>
<FormLabel component="legend">  
<Grid container spacing={1} style={stylemaster.GridContainerReportTitle}>
<Grid item>
<DonutSmallSharpIcon
style= {stylemaster.iconStyle}
/>  
</Grid>
<Grid item>
<Typography style = {stylemaster.Typography_title}>
Aggreagted Score 
</Typography>
</Grid>
</Grid>

</FormLabel>
{
 dataLoader.scoreLoading &&
 <CircularProgress syle = {{color:bgColors.font_blue}} />}
{
!dataLoader.scoreLoading &&
<div style = {{display:'flex', direction:'column', alignItems:'center', justifyContent:'left'}} > 
<div style={{width: '150px'}}> <PerfDonut
        data = {perfDonutData}
        /> </div>
<div style={{width: '150px'}}> <IrrigationDonut
data = {irrigationDonutData}
/> </div>
</div> 
}
</DialogContent>

<DialogContent dividers>
<FormLabel component="legend">  
<Grid container spacing={1} style={stylemaster.GridContainerReportTitle}>
<Grid item>
<GiPlantsAndAnimals
  style= {stylemaster.iconStyle}
  />  
  </Grid>
  <Grid item>
    <Typography style={stylemaster.Typography_title}>
    Crop cover 
  </Typography>
  </Grid>
  </Grid>
  </FormLabel>
  {dataLoader.polyCropLoading && <CircularProgress style = {{color:bgColors.grey_300}} />}
  {!dataLoader.polyCropLoading &&
  <div style = {{ marginLeft:'2rem',marginTop:' 0.5rem'}}>
   {season_crop_cover.map((d, index) => 
    <div style = {{display:'flex', direction:'row'}} key ={`${index}_seasoncrop`}>
    <CheckBox readOnly={true} 
    style = {{color: bgColors.grey_300, background:bgColors.grey_300}}
    type="checkbox" id={d.season} checked={d.crop} key ={`${index}_seasoncrop`}/>
    <Typography style ={stylemaster.Typography_body} key ={index}>{d.season}</Typography>
    </div>
    )}
</div>
}
</DialogContent>
  <DialogContent dividers>
    <FormLabel component="legend">  
    <Grid container spacing={1} style={stylemaster.GridContainerReportTitle}>
    <Grid item>
    <EqualizerSharpIcon
  style= {stylemaster.iconStyle}
  />  
  </Grid>
  <Grid item>
    <Typography style={stylemaster.Typography_title}>
  Seasonal Performance  
  </Typography>
  </Grid>

</Grid>
  </FormLabel>
  <BarChart
  data={SeasonalPerfBarData}
  />
  </DialogContent>



<DialogContent dividers>
<FormLabel component="legend">  
<Grid container spacing={1} style={stylemaster.GridContainerReportTitle}>
<Grid item>
<EqualizerSharpIcon
  style= {stylemaster.iconStyle}
/>  
</Grid>
<Grid item>
  <Typography style={stylemaster.Typography_title}>
Crop Performance  
</Typography>
</Grid>
</Grid>
</FormLabel>
  {dataLoader.scoreLoading &&
 <CircularProgress syle = {{color:bgColors.grey_300}} />}
{!dataLoader.scoreLoading &&
  <CropBarChart
  data={multiBarDataSet}
  />
}
</DialogContent> 
</>
);
}



export default LandView
